import {fetchMPMUsersStatistics} from '../../../entities/statistics/mpmUsers';

export const scope = 'MPM_USERS_STATS';
export const REFRESH_STATS = 'REFRESH_STATS';

export function fetchStatsIfNeeded(payload) {
  return (dispatch, getState) => {
    const {userStats} = getState().app.other.mpm;

    if (!userStats.info.isFetching && userStats.info.needRefresh)
      dispatch(fetchMPMUsersStatistics(payload, scope));
  };
}

export function refreshStats(payload) {
  return (dispatch, getState) => {
    const {userStats} = getState().app.other.mpm;

    if (!userStats.info.isFetching)
      dispatch(
        fetchMPMUsersStatistics(payload || userStats.info.lastPayload, scope),
      );
  };
}



// WEBPACK FOOTER //
// ./src/actions/app/other/mpm/users.js